/** @format */

import { Amplify, type ResourcesConfig } from "aws-amplify";
import {
	autoSignIn,
	signIn,
	signOut,
	type SignInInput,
	getCurrentUser,
} from "aws-amplify/auth";

const authConfig: ResourcesConfig["Auth"] = {
	Cognito: {
		userPoolId: "us-east-2_aC1b3hIGW",
		userPoolClientId: "28hc8tkdc66vsjppju0djma475",
	},
};

Amplify.configure({
	Auth: authConfig,
});

export const handleSignInUser = async ({ username, password }: SignInInput) => {
	try {
		const signInResponse = await signIn({ username, password });

		// // if signedInResponse is successful,return user data
		if (signInResponse && signInResponse.isSignedIn === true) {
			return {
				isSignedIn: true,
				user: signInResponse,
			};
		}

		// check further steps
		if (signInResponse && signInResponse.nextStep.signInStep !== "DONE") {
			return {
				isSignedIn: false,
				nextStep: signInResponse.nextStep,
			};
		}

		// default case
		return {
			isSignedIn: false,
		};
	} catch (error: any) {
		console.log(error);
		let errorMessage = "Unknown Error occurred";

		// Check for specific error types
		if (
			error.name === "NotAuthorizedException" ||
			error === "NotAuthorizedException"
		) {
			errorMessage = "Incorrect username or password.";
		} else if (error.name === "UserNotFoundException") {
			errorMessage = "User not found in our records, please sign up.";
		} else if (
			error.name === "UserAlreadyAuthenticatedException" ||
			error === "UserAlreadyAuthenticatedException"
		) {
			// User is already signed in with Cognito - return a special response
			// so the caller can redirect them to their profile
			return {
				isSignedIn: true,
				alreadyAuthenticated: true,
			};
		}

		throw new Error(errorMessage);
	}
};

export const handleAutoSignIn = async () => {
	try {
		const outPut = await autoSignIn();

		return outPut;
	} catch (error) {
		throw error;
	}
};

export const isAuthenticated = async () => {
	try {
		const user = await getCurrentUser();
		return !!user;
	} catch (error) {
		return false;
	}
};

export const handleSignOutUser = async () => {
	try {
		await signOut();
		return true;
	} catch (error) {
		throw error;
	}
};
